/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Input_PlaceholderInputs */

const en_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe what you want: "run 3 patrols on the floors"`)
};

const fr_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décris ce que tu veux : « lance 3 patrols sur les étages »`)
};

const ms_sg2_chat_input_placeholder = /** @type {(inputs: Chat_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beritahu apa yang anda mahu: "lancar 3 rondaan di tingkat"`)
};

/**
* | output |
* | --- |
* | "Describe what you want: \"run 3 patrols on the floors\"" |
*
* @param {Chat_Input_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_input_placeholder = /** @type {((inputs?: Chat_Input_PlaceholderInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Input_PlaceholderInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_input_placeholder(inputs)
	if (locale === "fr") return fr_chat_input_placeholder(inputs)
	return ms_sg2_chat_input_placeholder(inputs)
});